// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* modal */
.modal-report .modal-content {
  border-radius: 30px;
  min-width: 600px;
}

.modal-agent .modal-content {
  min-width: 600px;
  border-radius: 30px;
}
.btn-report-modal {
  background-color: #fd0d0d !important;
  width: 170px;
  height: 50px;
  border: none;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  color: #ffffff;
  border-radius: 12px;
}

.header-modal {
  color: #010404 !important;
  font-weight: 700 !important;
  font-size: 24px !important;
  line-height: 28.8px !important;
}

.close-icon {
  text-align: end;
  padding: 10px;
  color: #75788d;
}

.img-close {
  cursor: pointer;
}

.label-modal {
  font-weight: 700;
  font-size: 16px;
  color: #010404;
}

.form-input-modal {
  border-radius: 12px !important;
  border: 1px solid #e9ecef !important;
  color: #808282 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
}

.form-height {
  height: 50px;
}

/* Genrate modal */
.modal-genrate .modal-content {
  border-radius: 30px;
  min-width: 720px;
}

.modal-boots .modal-content {
  min-width: 500px;
  border-radius: 30px;
}
.modal-delete .modal-content {
  min-width: 496px;
  border-radius: 30px;
  height: 338px;
}
/* // add new mediaquery make for responsive */
@media only screen and (min-width: 310px) and (max-width: 991px) {
  .modal-delete .modal-content {
    min-width: 0 !important;
    height: 368px;
  }
}
.agent_modal_body h4 {
  color: #010404;
}
/* .agent_modal_body {
  padding: 20px !important;
} */
.upload_sec {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
.property_upload input[type="file"] {
  display: none;
}
.property_upload .upload--btn {
  cursor: pointer;
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background: rgba(22, 56, 115, 0.1);
  color: #163873;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.addproperty_form label {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.addproperty_form label span {
  color: #fd0d0d;
}
.addproperty_form .form-control {
  border-radius: 12px;
  border: 1px solid #e9ecef !important;
  background: var(--White, #fff);
  height: 50px !important;
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.img_grp {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 !important;
}

.modal_cancel_btn {
  display: flex;
  width: 160px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  background: #163873;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
}

.agent_modal_body .form-group input {
  border-radius: 12px;
  border: 1px solid var(--Stroke, #e9ecef) !important;
  background: var(--White, #fff);
  color: var(--Gray-1, #808282);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.details__booking h6 {
  color: var(--grayscale-light-text-2, #acaebe);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.details__booking p {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.box-booking {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 10px;
}

.btn_negotiate {
  display: flex;
  width: 220px;
  height: 50px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-radius: 12px;
  border: 1px solid #163873;
  color: #163873;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background-color: #fff;
}
.btn_actual {
  display: flex;
  width: 220px;
  height: 50px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-radius: 12px;
  background: #163873;
  color: var(--White, #fff);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
}
.btn_reject {
  display: flex;
  width: 150px;
  height: 50px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: rgba(253, 13, 13, 0.1);
  color: #fd0d0d;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
}
.btns_booking {
  gap: 10px;
}

/* Booking */
.booking-details .modal-content {
  min-width: 740px !important;
  border-radius: 30px;
}
/* // add new mediaquery make for responsive */

@media only screen and (min-width: 310px) and (max-width: 991px) {
  .booking-details .modal-content {
    min-width: 0 !important;
  }
}
.booking-label {
  font-weight: 700;
  font-size: 16px;
  color: #acaebe;
  line-height: 19.2px;
}

.booking-text-field {
  color: #010404;
  line-height: 19.2px;
  font-size: 16px;
  font-weight: 500;
}

.agent_modal_body {
  padding: 5px 50px 50px !important;
}

.btn_report_modal {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px !important;
  height: 30px;
  color: #fd0d0d;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
  border-radius: 6px;
  background: rgba(253, 13, 13, 0.1);
  text-align: center;
  margin: auto 0;
}

.modal_delete_btn {
  color: #fd0d0d;
  font-weight: 700;
  font-size: 14px;
  line-height: 16.8px;
  width: 120px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #fd0d0d;
}

.react-datepicker-wrapper {
  width: 100%;
}

.cancel__btn {
  min-width: 170px;
  min-height: 50px;
  background: #163873;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  color: #fff;
  border: none;
}

.delete__btn {
  min-width: 170px;
  min-height: 50px;
  border-radius: 12px;
  border: 1px solid #fd0d0d;
  color: #fd0d0d;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
}

.text__modal {
  font-size: 24px !important;
  font-weight: 600 !important;
  line-height: 28.8px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  color: #010404 !important;
}

.text__para {
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: center;
  color: #010404;
}

.search_agent .search_modal_agent {
  border-radius: 12px;
  border: 1px solid #e9ecef !important;
  background: var(--White, #fff);
  height: 50px !important;
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.agent_list_block {
  display: flex;
  align-items: center;
  gap: 15px;
}
.agents_list {
  padding: 15px 0px;
}
.agent_list_block h5 {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 5px;
}
.agent_list_block p {
  color: var(--Gray-1, #808282);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.agents_list ul li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  transition: 0.3s all;
  border-radius: 12px !important;
}
.agents_list ul .active {
  background: rgba(22, 56, 115, 0.1);
}
.agents_list ul li:hover {
  background: rgba(22, 56, 115, 0.1);
}
.agent_modal .modal-footer {
  justify-content: center;
  border: none;
}

.h5_text_modal {
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 19px !important;
  letter-spacing: 0px !important;
  color: #010404 !important;
}

.p_text_modal {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 17px !important;
  letter-spacing: 0px !important;
  color: #808282 !important;
}

.assign_modal_btn {
  font-size: 18px !important;
  font-weight: 700 !important;
  line-height: 22px !important;
  letter-spacing: 0em !important;
  text-align: left !important;
  height: 50px !important;
  min-width: 200px !important;
}

.text_modal_para {
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 19px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
}
/* facility work request request modal */
.save_changes {
  width: 120px;
}
.placeholder_color {
  color: #010404 !important;
}
/* change the  work modal required icon color */
.required_text {
  color: #fd0d0d !important;
}
/* add some changes make responsive seema */
@media only screen and (min-width: 310px) and (max-width: 425px) {
  .modal_cancel_btn {
    width: 100% !important;
  }
  section.img__container h4 {
    padding-top: 20px !important;
  }
}

/* landload */
@media only screen and (max-width: 767px) {
  .modal-boots .modal-content {
    min-width: auto !important;
  }

  .modal-agent .modal-content {
    min-width: auto !important;
  }

  .modal-agent .header-modal {
    font-size: 15px !important;
  }
  .comman_button_group {
    flex-direction: column;
  }
  .btn_negotiate {
    width: auto;
    min-width: 100%;
  }
  .btn_actual {
    width: auto;
    min-width: 100%;
  }
  .btn_reject {
    width: auto;
    min-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modal/modal.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;AACA,8CAA8C;AAC9C;EACE;IACE,uBAAuB;IACvB,aAAa;EACf;AACF;AACA;EACE,cAAc;AAChB;AACA;;GAEG;AACH;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;EACnD,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA,8CAA8C;;AAE9C;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA,wCAAwC;AACxC;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA,+CAA+C;AAC/C;EACE,yBAAyB;AAC3B;AACA,2CAA2C;AAC3C;EACE;IACE,sBAAsB;EACxB;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,aAAa;AACb;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* modal */\n.modal-report .modal-content {\n  border-radius: 30px;\n  min-width: 600px;\n}\n\n.modal-agent .modal-content {\n  min-width: 600px;\n  border-radius: 30px;\n}\n.btn-report-modal {\n  background-color: #fd0d0d !important;\n  width: 170px;\n  height: 50px;\n  border: none;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 24px;\n  color: #ffffff;\n  border-radius: 12px;\n}\n\n.header-modal {\n  color: #010404 !important;\n  font-weight: 700 !important;\n  font-size: 24px !important;\n  line-height: 28.8px !important;\n}\n\n.close-icon {\n  text-align: end;\n  padding: 10px;\n  color: #75788d;\n}\n\n.img-close {\n  cursor: pointer;\n}\n\n.label-modal {\n  font-weight: 700;\n  font-size: 16px;\n  color: #010404;\n}\n\n.form-input-modal {\n  border-radius: 12px !important;\n  border: 1px solid #e9ecef !important;\n  color: #808282 !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n}\n\n.form-height {\n  height: 50px;\n}\n\n/* Genrate modal */\n.modal-genrate .modal-content {\n  border-radius: 30px;\n  min-width: 720px;\n}\n\n.modal-boots .modal-content {\n  min-width: 500px;\n  border-radius: 30px;\n}\n.modal-delete .modal-content {\n  min-width: 496px;\n  border-radius: 30px;\n  height: 338px;\n}\n/* // add new mediaquery make for responsive */\n@media only screen and (min-width: 310px) and (max-width: 991px) {\n  .modal-delete .modal-content {\n    min-width: 0 !important;\n    height: 368px;\n  }\n}\n.agent_modal_body h4 {\n  color: #010404;\n}\n/* .agent_modal_body {\n  padding: 20px !important;\n} */\n.upload_sec {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n.property_upload input[type=\"file\"] {\n  display: none;\n}\n.property_upload .upload--btn {\n  cursor: pointer;\n  width: 60px;\n  height: 60px;\n  border-radius: 12px;\n  background: rgba(22, 56, 115, 0.1);\n  color: #163873;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n.addproperty_form label {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.addproperty_form label span {\n  color: #fd0d0d;\n}\n.addproperty_form .form-control {\n  border-radius: 12px;\n  border: 1px solid #e9ecef !important;\n  background: var(--White, #fff);\n  height: 50px !important;\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.img_grp {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 !important;\n}\n\n.modal_cancel_btn {\n  display: flex;\n  width: 160px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 12px;\n  background: #163873;\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n}\n\n.agent_modal_body .form-group input {\n  border-radius: 12px;\n  border: 1px solid var(--Stroke, #e9ecef) !important;\n  background: var(--White, #fff);\n  color: var(--Gray-1, #808282);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.details__booking h6 {\n  color: var(--grayscale-light-text-2, #acaebe);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.details__booking p {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.box-booking {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  gap: 10px;\n}\n\n.btn_negotiate {\n  display: flex;\n  width: 220px;\n  height: 50px;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  border-radius: 12px;\n  border: 1px solid #163873;\n  color: #163873;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  background-color: #fff;\n}\n.btn_actual {\n  display: flex;\n  width: 220px;\n  height: 50px;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  border-radius: 12px;\n  background: #163873;\n  color: var(--White, #fff);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n}\n.btn_reject {\n  display: flex;\n  width: 150px;\n  height: 50px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  background: rgba(253, 13, 13, 0.1);\n  color: #fd0d0d;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n}\n.btns_booking {\n  gap: 10px;\n}\n\n/* Booking */\n.booking-details .modal-content {\n  min-width: 740px !important;\n  border-radius: 30px;\n}\n/* // add new mediaquery make for responsive */\n\n@media only screen and (min-width: 310px) and (max-width: 991px) {\n  .booking-details .modal-content {\n    min-width: 0 !important;\n  }\n}\n.booking-label {\n  font-weight: 700;\n  font-size: 16px;\n  color: #acaebe;\n  line-height: 19.2px;\n}\n\n.booking-text-field {\n  color: #010404;\n  line-height: 19.2px;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.agent_modal_body {\n  padding: 5px 50px 50px !important;\n}\n\n.btn_report_modal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 120px !important;\n  height: 30px;\n  color: #fd0d0d;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n  border-radius: 6px;\n  background: rgba(253, 13, 13, 0.1);\n  text-align: center;\n  margin: auto 0;\n}\n\n.modal_delete_btn {\n  color: #fd0d0d;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16.8px;\n  width: 120px;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid #fd0d0d;\n}\n\n.react-datepicker-wrapper {\n  width: 100%;\n}\n\n.cancel__btn {\n  min-width: 170px;\n  min-height: 50px;\n  background: #163873;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 19px;\n  color: #fff;\n  border: none;\n}\n\n.delete__btn {\n  min-width: 170px;\n  min-height: 50px;\n  border-radius: 12px;\n  border: 1px solid #fd0d0d;\n  color: #fd0d0d;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 19px;\n  letter-spacing: 0em;\n}\n\n.text__modal {\n  font-size: 24px !important;\n  font-weight: 600 !important;\n  line-height: 28.8px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  color: #010404 !important;\n}\n\n.text__para {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 19px;\n  letter-spacing: 0px;\n  text-align: center;\n  color: #010404;\n}\n\n.search_agent .search_modal_agent {\n  border-radius: 12px;\n  border: 1px solid #e9ecef !important;\n  background: var(--White, #fff);\n  height: 50px !important;\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.agent_list_block {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n.agents_list {\n  padding: 15px 0px;\n}\n.agent_list_block h5 {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 5px;\n}\n.agent_list_block p {\n  color: var(--Gray-1, #808282);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.agents_list ul li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  transition: 0.3s all;\n  border-radius: 12px !important;\n}\n.agents_list ul .active {\n  background: rgba(22, 56, 115, 0.1);\n}\n.agents_list ul li:hover {\n  background: rgba(22, 56, 115, 0.1);\n}\n.agent_modal .modal-footer {\n  justify-content: center;\n  border: none;\n}\n\n.h5_text_modal {\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  line-height: 19px !important;\n  letter-spacing: 0px !important;\n  color: #010404 !important;\n}\n\n.p_text_modal {\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  line-height: 17px !important;\n  letter-spacing: 0px !important;\n  color: #808282 !important;\n}\n\n.assign_modal_btn {\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  line-height: 22px !important;\n  letter-spacing: 0em !important;\n  text-align: left !important;\n  height: 50px !important;\n  min-width: 200px !important;\n}\n\n.text_modal_para {\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 19px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n}\n/* facility work request request modal */\n.save_changes {\n  width: 120px;\n}\n.placeholder_color {\n  color: #010404 !important;\n}\n/* change the  work modal required icon color */\n.required_text {\n  color: #fd0d0d !important;\n}\n/* add some changes make responsive seema */\n@media only screen and (min-width: 310px) and (max-width: 425px) {\n  .modal_cancel_btn {\n    width: 100% !important;\n  }\n  section.img__container h4 {\n    padding-top: 20px !important;\n  }\n}\n\n/* landload */\n@media only screen and (max-width: 767px) {\n  .modal-boots .modal-content {\n    min-width: auto !important;\n  }\n\n  .modal-agent .modal-content {\n    min-width: auto !important;\n  }\n\n  .modal-agent .header-modal {\n    font-size: 15px !important;\n  }\n  .comman_button_group {\n    flex-direction: column;\n  }\n  .btn_negotiate {\n    width: auto;\n    min-width: 100%;\n  }\n  .btn_actual {\n    width: auto;\n    min-width: 100%;\n  }\n  .btn_reject {\n    width: auto;\n    min-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
